import { FC } from "react";
import Services from "../../../components/Booking-clientSide/appointment/Services";
import ServicesSideBar from "../../../components/Booking-clientSide/appointment/ServicesSideBar";

interface BookingAppointmentProps {}

const BookingAppointment: FC<BookingAppointmentProps> = ({}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 max-h-[100vh] p-1 overflow-y-auto">
      <div className="col-span-1 md:col-span-2 ">
        <Services />
      </div>
      <div className="col-span-1  ">
        {" "}
        <ServicesSideBar />
      </div>
    </div>
  );
};

export default BookingAppointment;
